import { render, staticRenderFns } from "./ColumnSettingsMenu.vue?vue&type=template&id=2f31a0b1"
import script from "./ColumnSettingsMenu.vue?vue&type=script&lang=js"
export * from "./ColumnSettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./ColumnSettingsMenu.vue?vue&type=style&index=0&id=2f31a0b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports